(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
if (!customElements.get('epm-account-trigger')) {
  class EpmAccountTrigger extends HTMLElement {
    connectedCallback() {
      this.account = this.querySelector('shopify-account');
      this.onEnter = this.openOnHover.bind(this);
      this.onMove = this.trackPointer.bind(this);
      this.onOpen = () => {
        if (!this.hoverRequested) return;
        document.addEventListener('pointermove', this.onMove);
        document.addEventListener('keydown', this.onKey, true);
      };
      this.onClose = this.stopTracking.bind(this);
      this.onKey = this.stopTracking.bind(this);
      this.addEventListener('pointerenter', this.onEnter);
      this.account?.addEventListener('open', this.onOpen);
      this.account?.addEventListener('close', this.onClose);
    }

    disconnectedCallback() {
      this.stopTracking();
      this.removeEventListener('pointerenter', this.onEnter);
      this.account?.removeEventListener('open', this.onOpen);
      this.account?.removeEventListener('close', this.onClose);
    }

    openOnHover(event) {
      if (event.pointerType !== 'mouse' ||
          !matchMedia('(min-width: 751px) and (hover: hover) and (pointer: fine)').matches) return;
      const root = this.account?.shadowRoot;
      const button = root?.querySelector('button[aria-haspopup="dialog"]');
      this.dialog = root?.querySelector('dialog');
      if (!button || !this.dialog || this.dialog.open) return;
      this.hoverRequested = true;
      button.click();
    }

    trackPointer(event) {
      if (event.pointerType !== 'mouse' || !this.dialog?.open) {
        this.stopTracking();
        return;
      }
      const trigger = this.getBoundingClientRect();
      const menu = this.dialog.getBoundingClientRect();
      const contains = rect => event.clientX >= rect.left && event.clientX <= rect.right &&
        event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (contains(trigger) || contains(menu)) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      } else if (!this.closeTimer) {
        this.closeTimer = setTimeout(() => {
          this.dialog?.querySelector('#close-button')?.click();
          this.stopTracking();
        }, 200);
      }
    }

    stopTracking() {
      this.hoverRequested = false;
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
      document.removeEventListener('pointermove', this.onMove);
      document.removeEventListener('keydown', this.onKey, true);
    }
  }
  customElements.define('epm-account-trigger', EpmAccountTrigger);
}


  } catch(e) { console.error(e); }
})();
})();
